import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BarChartIcon from "@mui/icons-material/BarChart";
import InsightsIcon from "@mui/icons-material/Insights";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Tabs,
  Tab
} from "@mui/material";
import { plan_category, plan_types_category } from "./constants";
import { plan_level_enums } from "shared/modals/managePlans/constant";
import { Icons } from "assets";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import { SchoolAnalyticsView } from "pages/schoolAnalytics";

import Filter from "shared/components/filterButton";
import Loader from "shared/components/loader/animation";
import Pagination from "shared/components/pagination";
import { toastMessage } from "shared/components/toast";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import useDebounce from "shared/customHooks/useDebounce";
import useWindowSize from "shared/customHooks/windowSize";
import Confirmation from "shared/modals/confirmation";
import SchoolPlanDetail from "shared/modals/schoolPlanDetail";
import { routeConstant } from "shared/routes/routesConstant";
import SchoolStatisticsDashboard from "./statisticsDashboard";

import {
  // blockUserService,
  // individualAccountService,
  statsIndividualKidsService,
  // unblockUserService,
  getAllPlansService,
  activatePlanService,
  inActivatePlanService
} from "shared/services/productManagerService";

import SkeletonLoader from "./skeletonLoader";
import styles from "./style.module.scss";

/** Kept in `?tab=` so coming back from a school's detail reopens the tab. */
const TAB_KEYS = ["plans", "statistics", "analytics"];

function SchoolUsers() {
  const screenWidth = useWindowSize();
  const [activePage, setActivePage] = useState<number>(1);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = Math.max(0, TAB_KEYS.indexOf(searchParams.get("tab") ?? ""));
  const setActiveTab = (index: number) =>
    setSearchParams(index ? { tab: TAB_KEYS[index] } : {}, { replace: true });
  // const [allAccounts, setAllAccounts] = useState<any>(null);
  const [action, setAction] = useState<any>({
    label: "",
    type: ""
  });

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [actionLoader, setActionLoader] = useState<boolean>(false);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [stats, setStats] = useState<any>({});
  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [selectedAgeRange, setSelectedAgeRange] = useState<any>(null);
  const [total, setTotal] = useState<any>(null);
  const [filterDates, setFilterDates] = useState<any>({
    startDate: null,
    endDate: null
  });
  const [allPlans, setAllPlans] = useState<any>(null);
  const [dataLoader, setDataLoader] = useState<boolean>(true);
  console.log("allPlans", allPlans);
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setSelectedItem(null);
  };

  const handleOpenConfirm = (label: String, type: String, item: any) => {
    console.log("item", item);
    setOpenConfirm(true);
    setAction({
      label: label,
      type: type
    });
    setSelectedItem(item);
  };

  const handleActions = (action: any) => {
    setActionLoader(true);
    let service =
      action.type === "active"
        ? activatePlanService
        : action.type === "inactive"
        ? inActivatePlanService
        : null;
    service?.(selectedItem?.id)
      .then(({ data }) => {
        toastMessage("success", data?.message);
        getAllPlans(true);
        setActionLoader(false);
        handleCloseConfirm();
      })
      .catch((err) => {
        setActionLoader(false);
        toastMessage("error", err?.response?.data?.message || "Action failed");
      });
  };

  useDebounce(
    () => {
      const trimmedSearch = search.trim();
      if (trimmedSearch === searchText) return;
      setSearchText(trimmedSearch);
      setActivePage(1);
    },
    [search],
    800
  );

  useBreadcrumbs({
    title: "School Users",
    path: routeConstant.aliflailaSchoolUsers.path
  });

  const getStats = () => {
    statsIndividualKidsService()
      .then(({ data: { status, data } }) => {
        if (status) {
          setStats(data);
        }
      })
      .catch((err) => {});
  };

  const getAllPlans = (bool: boolean) => {
    if (bool) {
      setDataLoader(true);
    }
    // Create filter object with all filter criteria
    const filterParams = {
      category: plan_category[2].value,
      status: selectedFilter?.value
    };

    console.log("Filter Params:", filterParams);
    console.log("Selected Filter:", selectedFilter);

    getAllPlansService(
      plan_category[2]?.value,
      activePage,
      plan_types_category[0].value,
      searchText,
      selectedFilter?.value
    )
      .then(({ data }) => {
        setAllPlans(data?.data?.data);
        setDataLoader(false);
        setTotalPage(data?.data?.last_page);
        setTotal(data?.data?.total);
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        toastMessage("error", err?.response?.data?.message);
        setDataLoader(false);
      });
  };

  useEffect(() => {
    getAllPlans(true);
    // eslint-disable-next-line
  }, [searchText, activePage, selectedFilter, filterDates]);

  useEffect(() => {
    getStats();
  }, []);

  const cards = [
    {
      title: "Total User Accounts",
      stats: stats?.total,
      icon: null
    },
    {
      title: "Free Users Accounts",
      stats: stats?.free,
      icon: null
    },
    {
      title: "Subscribed User Accounts",
      stats: stats?.memberships,
      icon: null
    }
  ];

  const filterOption = [
    {
      option: "Inactive",
      value: 0
    },
    {
      option: "Active",
      value: 1
    },
    {
      option: "Pending",
      value: 3
    },
    {
      option: "Expired",
      value: 2
    }
  ];

  const onChangeDate = (dates: any) => {
    const [start, end] = dates;
    setFilterDates({
      startDate: start,
      endDate: end
    });
    setActivePage(1);
  };

  const resetFilters = () => {
    setFilterDates({
      startDate: null,
      endDate: null
    });
    setSelectedFilter(null);
    setSelectedAgeRange(null);
    setSearch("");
    setSearchText("");
    setActivePage(1);
  };

  return (
    <div>
      {/* <Grid container spacing={2} marginBottom={"20px"}>
        {cards?.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <Grid item xs={12} md={4}>
                <Card
                  Icon={item?.icon}
                  stats={item?.stats}
                  title={item?.title}
                  isLoading={false}
                />
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid> */}
      <Box
        className={classNames(styles.topLevelContainer, {
          [styles.analyticsTab]: activeTab === 2,
        })}
      >
        <Box className={styles.tabsContainer}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            className={styles.tabs}
          >
            <Tab label="School Plans" />
            <Tab label="Statistics Dashboard" icon={<BarChartIcon />} iconPosition="start" />
            <Tab label="School Analytics" icon={<InsightsIcon />} iconPosition="start" />
          </Tabs>
        </Box>

        {activeTab === 2 ? (
          <SchoolAnalyticsView embedded />
        ) : activeTab === 1 ? (
          <SchoolStatisticsDashboard />
        ) : (
          <>
        <Box className={styles.topHeadContainer}>
          <Box>
            <div className={styles.tableHeading}>School Accounts</div>
            <div className={styles.tableSubHeading}>
              Manage school accounts from here.
            </div>
          </Box>
          <Box className={styles.filterContainer}>
            {searchText?.length ||
            selectedAgeRange ||
            selectedFilter ||
            (filterDates?.startDate && filterDates?.startDate) ? (
              <div style={{ marginRight: "10px" }}>
                <button
                  className={styles.resetBtn}
                  onClick={() => resetFilters()}
                >
                  Reset Filters
                </button>
              </div>
            ) : null}

            {/* <div className={styles.rangeInputWrapper}>
              <ReactDatePicker
                className={styles.range_input}
                dateFormat="d MMM"
                selected={filterDates?.startDate}
                onChange={(date: any) => onChangeDate(date)}
                startDate={filterDates?.startDate}
                endDate={filterDates?.endDate}
                selectsRange
                placeholderText="Search by Date"
              />
            </div> */}
            <div className={styles.userFilter}>
              <Filter
                label="Search by Membership Status"
                filterOption={filterOption}
                filterStyles={styles.filterStyles}
                selectedOption={selectedFilter}
                setSelectedOption={setSelectedFilter}
                setActivePage={setActivePage}
              />
            </div>
            <div className={styles.gridContainer}>
              <Icons.SearchIcon className={styles.searchIcon} />
              <input
                placeholder="Search"
                className={styles.input}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </Box>
        </Box>
        <Box className={styles.counterContainer}>Total Results: {total}</Box>

        <TableContainer
          component={Paper}
          className={styles.table}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={styles.tableHead}>
                <TableCell>School Name</TableCell>
                <TableCell>Plan Title</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Discount</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataLoader ? (
                <SkeletonLoader />
              ) : (
                allPlans?.map((item: any) => {
                  console.log("Plan Duration:", item?.current_plan?.duration);
                  return (
                    <>
                      <TableRow className={styles.tableRow}>
                        <TableCell>
                          {item?.school_name ? item?.school_name : "--"}
                        </TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "7px"
                            }}
                          >
                            {item?.name ? item?.name : "--"}
                          </div>
                        </TableCell>
                        <TableCell>
                          {item?.level ===
                            plan_level_enums.in_app_international ||
                          item?.level === plan_level_enums.international
                            ? "$"
                            : "Rs."}
                          {item?.price}{" "}
                        </TableCell>
                        <TableCell>{item?.duration + " Days"}</TableCell>

                        <TableCell>
                          {item?.is_discounted ? "Available" : "Not Available"}
                        </TableCell>
                        <TableCell>
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            className={styles.actionBtn}
                          >
                            <Tooltip title={"View"} arrow>
                              <button
                                onClick={() => {
                                  setOpenAdd(true);
                                  setSelectedItem(item);
                                }}
                              >
                                <RemoveRedEyeIcon />
                              </button>
                            </Tooltip>
                            {/* <Tooltip
                              title={`${
                                item?.status ? "Deactivate" : "Activate"
                              }`}
                              arrow
                            >
                              <button
                                onClick={() =>
                                  handleOpenConfirm(
                                    `Are you sure you want to ${
                                      item?.status === 1
                                        ? "inactivate"
                                        : "activate"
                                    } this plan?`,
                                    item?.status === 1 ? "inactive" : "active",
                                    item
                                  )
                                }
                              >
                                {item?.status !== 1 ? (
                                  <Icons.SchoolDeactivate />
                                ) : (
                                  <Icons.SchoolActivate />
                                )}
                              </button>
                            </Tooltip> */}
                          </Box>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {allPlans?.length === 0 && !dataLoader && (
          <div className={styles.noUserCard}>
            <Icons.NoUsersData />
            <h5>No Data Found</h5>
          </div>
        )}

        <SchoolPlanDetail
          open={openAdd}
          handleClose={() => {
            setOpenAdd(false);
            setSelectedItem(null);
          }}
          selectedItem={selectedItem}
        />

        {totalPage > 1 && (
          <Pagination
            totalPages={totalPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        )}

        <Confirmation
          text={action.label}
          handleClose={handleCloseConfirm}
          open={openConfirm}
          handleClick={() => handleActions(action)}
        />

        {actionLoader && <Loader />}
        </>
        )}
      </Box>
    </div>
  );
}

export default SchoolUsers;
